module.exports = __webpack_public_path__ + "img/hr-H-T-135-unload-connect.8733809c.png";